export enum PathFor {
  //  onboarding related
  onBoardingPage = "/on-Boarding",
  enterMobileNumberPage = "/enter-mobile-number",
  enterOtpPage = "/enter-otp",
  profileCreationPage = "/profile-creation",
  goalSelectionPage = "/goal-selection",
  dailyPracticeDurationSelectionPage = "/daily-practice-duration-selection",
  dailyQuestionsToPracticeSelectionPage = "/daily-questions-to-practice-selection",
  allowPushNotificationsPage = "/allow-push-notifications",
  bestTimeToPracticeSelectionPage = "/best-time-to-practice-selection",
  levelOneAnimationPage = "/level-one-animation",
  levelTwoAnimationPage = "/level-two-animation",
  levelThreeAnimationPage = "/level-three-animation",
  levelFourAnimationPage = "/level-four-animation",
  welcomeBonusPage = "/welcome-bonus",
  FirstTopicSelectionPage = "/first-topic-selection",
  startPracticingNowPage = "/start-practicing-now",

  // myExamsPage related
  allExamsPage = "/all-exams",
  sectionPage = "/section/:sectionId",
  myExamsSearchPage = "/my-exams-search",

  // mock test related
  mockTestPage = "/mock-tests/:mockTestId",
  mockTestSeriesPage = "/mock-test-series/:mockTestSeriesName",
  myMockTestActivityPage = "/my-mock-test-activity/:mockTestSeriesName",
  mockTestsSearchPage = "/mock-tests-search",

  // settings related
  moreSettingsPage = "/more-settings",
  myNotificationSettingsPage = "/my-notification-settings",
  myNotificationsPage = "/my-notifications",

  // friends and requests
  friendsAndRequestsPage = "/friends-and-requests",

  // profilePage related
  profilePage = "/profile",
  savedQuestionsPage = "/saved-questions",
  savedQuestionsNotAvailablePage = "/saved-questions-not-available",
  savedQuestionPage = "/saved-question/:savedQuestionObjectId",
  reportedQuestionsPage = "/reported-questions",
  profileEditPage = "/profile-edit",

  // purchase related
  planPurchasePage = "/plan-purchase/",
  allPaymentsPage = "/all-payments",
  noPaymentHistoryAvailablePage = "/no-payment-history-available",

  // plan related
  userPlanPage = "/user-plan",

  //  quiz related
  quizInfoPage = "/topic/:topicId/quiz-info/:quizId",
  quizPage = "/quiz/:quizId",
  quizResultPage = "/quiz-result/:quizId",

  improvementQuizPage = "/improvement-quiz/:quizId",
  improvementQuizInfoPage = "/topic/:topicId/improvent-quiz-info/:quizId",
  quizCompletedAnimationsPage = "/quiz-completed-animations/:quizId",
  improvementQuizCompletedAnimationsPage = "/improvement-quiz-completed-animations/:quizId",

  topicCompletedPage = "/topic-completed/:topicId",
  topicCompletedAnimationsPage = "/topic-completed-animations/:topicId",
  quizReviewPage = "/quiz-review",

  // revision match related
  revisionMatchResultPage = "/revision-match-result/:revisionMatchId",
  lookingForOpponentPage = "/looking-for-opponent/revision/:revisionId",
  revisionMatchPage = "/revision-match/:revisionMatchId",
  revisionMatchReviewPage = "/revision-match-review/:revisionMatchId",
  leaderBoardPage = "/leader-board",

  //  roots
  productsPage = "/products",
  homePage = "/home",
  myExamsPage = "/my-exams",
  myRevisionsPage = "/my-revisions",
  growthPage = "/growth",
  mockTestsPage = "/mock-tests",
  liveMatchesAndFriendsPage = "/live-matches-and-friends",

  someBigChangesPage = "/some-big-changes",

  // topic related
  topicPage = "/topic/:topicId",

  // neo ai coach related
  mistakeFixerPage = "/mistake-fixer/:selectedUserGoalId",
  speedImproverPage = "/speed-improver/:selectedUserGoalId",

  // error
  somethingWentWrongPage = "/something-went-wrong",

  // topic match related
  topicMatchPage = "/topic-match/:topicMatchId",
  topicMatchResultPage = "/topic-match-result/:topicMatchId",
  topicMatchReviewPage = "/topic-match-review/:topicMatchId",
  topicMatchInfoPage = "/topic-match-info/:topicMatchId",
}

export enum TopicMode {
  practiceMode = "practice_mode",
  matchMode = "match_mode",
}

export enum MockTestResultStatus {
  resultAwaited = "result_awaited",
  resultOut = "result_out",
  resultSeen = "result_seen",
}

export enum MockTestCategory {
  thisWeek = "this_week",
  liveNow = "live_now",
  upcoming = "upcoming",
  missedTests = "missed_tests",
  submittedMockTests = "submitted_tests",
}

export enum MockTestSeriesType {
  previousYearPapers = "previous_year_papers",
  fullLengthMocks = "full_length_mocks",
  nationalSeries = "national_series",
}

export enum SocketMessageType {
  // there are two types of match
  // 1. topic match
  // 2. revision match

  // revision page
  myRevisions = "my_revisions",
  revisionMatches = "live_matches",
  removeMatch = "remove_match",

  // looking for opponent page
  opponentJoined = "opponent_joined",
  newMatchAvailable = "new_match_available",
  redirectToMatch = "redirect_to_match",
  opponentDisconnected = "opponent_disconnected",
  matchUnavailable = "match_unavailable",

  // revision/topic match page
  startMatch = "start_match",
  newQuestion = "new_question",
  correctAnswer = "correct_answer",
  matchFinished = "match_finished",

  // revision/topic match result page
  rematchRequest = "rematch_request",
  rematchDeclined = "rematch_declined",
  rematchStarted = "rematch_started",
  rematchCanceled = "rematch_cancelled",
  newMessageRecieved = "player_message",
  playerStatusUpdate = "player_status_update",

  // topic bottom sheet during match mode
  matchModeOpponents = "match_mode_opponents",
  lobbyEvent = "lobby_event",
  // opponentJoined = "opponent_joined",
  // inviteResponse = "invite_response"
  // startMatch = "start_match",
  // playerStatusUpdate = "player_status_update",

  inviteResponse = "invite_response",

  // app socket
  inviteReceived = "invite_received",
  friendshipStatus = "friendship_status",
  liveTopicMatches = "live_matches",
  inviteExpired = "invite_expired",
  // liveMatches = "live_matches",
  // startMatch = "start_match",
  // playerStatusUpdate = "player_status_update",

  // friend requests related
  friendRequestResponse = "friend_request_response",
  friendRequest = "friend_request",
  friendRequestError = "friend_request_error",
  friendRemoved = "friend_removed",
}

export enum SocketAction {
  // -------------------- app socket
  readyUp = "ready_up",
  leaveLobby = "leave_lobby",
  respondFriendRequest = "respond_friend_request",
  unfriend = "unfriend",
  sendFriendRequest = "send_friend_request",
  inviteResponse = "invite_response",

  // -------------------- topic mode
  assignOpponent = "assign_opponent",
}

export enum RevisionMatchJoinedAs {
  revisor = "revisor",
  opponent = "opponent",
}

export enum TopicMatchJoinedAs {
  inviter = "user",
  opponent = "opponent",
}

export enum MatchResultStatus {
  lost = "lost",
  won = "won",
  draw = "draw",
}

export enum RevisionType {
  bronze = "bronze",
  silver = "silver",
  gold = "gold",
  platinum = "platinum",
  bonus = "bonus",
}

export enum TimelineType {
  revision = "revision",
  topical = "topical",
  mockTest = "mock_test",
}

export enum MockTestEventType {}

export enum RevisionEventType {
  revisionWon = "revision_won",
  revisionLost = "revision_lost",
  revisionDraw = "revision_draw",
  helpedWithRevision = "helped_with_revision",
}

export enum TopicEventType {
  topicUnlocked = "topic_unlocked",
  topicExpired = "topic_expired",
  topicExtended = "topic_extended",
  level1Started = "level_1_started",
  level2Started = "level_2_started",
  level3Started = "level_3_started",
  level4Started = "level_4_started",
  level1Completed = "level_1_completed",
  level2Completed = "level_2_completed",
  level3Completed = "level_3_completed",
  level4Completed = "level_4_completed",
  topicResumed = "topic_resumed",
  topicCompleted = "topic_completed",
  quizStarted = "quiz_started",
  quizCompleted = "quiz_completed",
  quizCreated = "quiz_created",
  improvementQuizStarted = "improvement_quiz_started",
  improvementQuizCompleted = "improvement_quiz_completed",
  improvementQuizCreated = "improvement_quiz_created",
}

export enum DaysName {
  sunday = "sunday",
  monday = "monday",
  tuesday = "tuesday",
  wednesday = "wednesday",
  thursday = "thursday",
  friday = "friday",
  saturday = "saturday",
}

export enum CircleType {
  weak = "weak",
  slow = "slow",
  strong = "strong",
}

export enum DailyGoalType {
  motivational = "motivational",
  timeBased = "time_based",
  questionBased = "question_based",
}

export enum FontFamily {
  gilroy = "Gilroy",
  museoSansDisplay = "Museo Sans Display",
}

export enum DeviceScreenSize {
  small = "small",
  medium = "medium",
  large = "large",
}

export enum QuizStatus {
  started = "started",
  waiting = "waiting",
  finished = "finished",
}

export enum TopicStatus {
  started = "started",
  notYetStarted = "not-yet-started",
  completed = "completed",
}

export enum TopicLockStatus {
  locked = "locked",
  unlocked = "unlocked",
}

export enum PaymentStatus {
  authorized = "authorized", // pending
  created = "created", // pending
  captured = "captured", // success
  failed = "failed", // failed
  refunded = "refunded", //refunded

  // for subscriptions
  authenticated = "authenticated", // pending
  pending = "pending", // pending
  cancelled = "cancelled", // cancelled
  charged = "charged", // success
  active = "active", // success
  paused = "paused", // failed
  resumed = "resumed", // failed
  activated = "activated", // failed
  halted = "halted", // failed
  updated = "updated", // failed
  completed = "completed", // will not come in future
}

export enum MockTestStatus {
  draft = "draft",
  ready = "ready",
  approved = "approved",
  published = "published",
  released = "released",
  archived = "archived",
  rejected = "rejected",
  unpublished = "unpublished",
}

export enum MockTestDifficultyLevel {
  easy = "easy",
  medium = "medium",
  hard = "hard",
}

export enum QuizAttemptLanguage {
  primaryLanguage = "primary_language",
  secondaryLanguage = "secondary_language",
}

export enum MockTestTagType {
  salientFeature = "salient_features",
  fill = "fill",
  starred = "starred",
  chip = "chips",
  targetExams = "target_exams",
}

export enum SubscriptionPlanType {
  practice = "practice",
  success = "success",
  topper = "topper",
}

export enum MockTestAttemptStatus {
  started = "started",
  notYetStarted = "not-yet-started",
  completed = "completed",
}

export const enum AppLanguage {
  english = "english",
  hindi = "hindi",
  // assamese = "assamese",
  // bengali = "bengali",
  // gujarati = "gujarati",
  // kannada = "kannada",
  // malayalam = "malayalam",
  // marathi = "marathi",
  // odia = "odia",
  // punjabi = "punjabi",
  // tamil = "tamil",
  // telugu = "telugu",
  // urdu = "urdu",
}

export const enum UserType {
  staff = "staff",
  teacher = "teacher",
  student = "student",
}

export const enum DataPointsEvent {
  a1 = "ques_opt_during_quiz_a1",
  b1 = "choose_ques_opt_during_quiz_b1",
  c1 = "ques_opt_correct_opt_during_quiz_c1",
  c2 = "ques_opt_correct_opt_quiz_report_c2",
  c3 = "ques_opt_correct_opt_saved_question_c3",
  c4 = "ques_opt_correct_opt_activity_history_c4",
  d1 = "ques_opt_correct_opt_exp_during_quiz_d1",
  d2 = "ques_opt_correct_opt_exp_quiz_report_d2",
  d3 = "ques_opt_correct_opt_exp_saved_question_d3",
  d4 = "ques_opt_correct_opt_exp_activity_history_d4",
  e1 = "see_explanation_clicked_e1",
}
